const BASE_URL = process.env.REACT_APP_API_URL;

const API = {

  //  api's for ............SelLMS
     account : {
       register : `${BASE_URL}/Account/Individual/Register`,
     },

     dashboard1 : {
      getSelLearnerData : `${BASE_URL}/indv/Dashboard/LearnerDashboard`,
      getProAdminData : `${BASE_URL}/indv/Dashboard/SuperAdminDashboard`,
     },


     // api's for .......................OrgLMS

     businessGroup : {
     getList   :  `${BASE_URL}/BusinessGroup/GetList`,
     getDetails: (id) => `${BASE_URL}/BusinessGroup/GetDetails?businessGroupId=${id}`,
     getManagerDetail: `${BASE_URL}/BusinessGroup/Manager/Get-Detail`, 

     addBusinessGroupByAdmin : `${BASE_URL}/BusinessGroup/Add-BusinessGroupByAdmin`,

     // /api/BusinessGroup/Manager-Status

     //  /api/BusinessGroup/Get-BusinessGroupByManager

     //  /api/BusinessGroup/Add-BusinessGroupByManager

     // /api/BusinessGroup/Admin/PendingList

     //  /api/BusinessGroup/Approve-BusinessGroup

     },

     businessGroupField : {
      addField  :  `${BASE_URL}/BusinessGroupField/Add-Field`,
      getList : `${BASE_URL}/BusinessGroupField/GetList`,



      //  /api/BusinessGroupField/GetList

      //  /api/BusinessGroupField/GetById

      //  /api/BusinessGroupField/Get-Detail
     },

     charts : {
      getTrainingChart : (trainingId) => `${BASE_URL}/Charts/Learner/GetTrainingChart?trainingId=${trainingId}`,
     },

     chats : {
      addChat  :  `${BASE_URL}/Chats/New-Chat/Users`,
       getMentorGroupList : (userId) => `${BASE_URL}/api/Chats/Mentor/GroupList?mentorId=${userId}`,
       addMentorGroup : `${BASE_URL}/Chats/mentor/group/Create`,
       create  :  `${BASE_URL}/Chats/private/Create`,
       sendMessage : `${BASE_URL}/Chats/Send-messages`,
       getMessage : (conversationId) => `${BASE_URL}/Chats/Get-Messagess?conversationId=${conversationId}`,
       downloadMessageAttachment : (messageId) => `${BASE_URL}/Chats/Download-Message-Attachment?messageId=${messageId}`,


       //   /api/Chats/private/Create
     },

     dashboard :{
  adminDashboard : `${BASE_URL}/Dashboard/AdminDashboard`, 
  mentorDashboard : `${BASE_URL}/Dashboard/MentorDashboard`,
  managerDashboard : `${BASE_URL}/Dashboard/ManagerDashboard`,
  learnerDashboard : `${BASE_URL}/Dashboard/LearnerDashboard`, 
}





};

export default API;